import { NavLink, useNavigate } from "react-router-dom";
import { PiBuildingApartmentThin } from "react-icons/pi";
import { PiMoney } from "react-icons/pi";
import { LuHotel } from "react-icons/lu";
import { BiSolidUserDetail } from "react-icons/bi";
import { TiMessage } from "react-icons/ti";
import { CiInstagram, CiYoutube } from "react-icons/ci";
import { FiFacebook } from "react-icons/fi";
import { useEffect, useState } from "react";
// import logo from "/assets/img/logo/logo_trans.png";

export default function Header() {
  const [login, setLogin] = useState("Login");
  useEffect(() => {
    const chekLocalStorage = localStorage.getItem("token");
    if (chekLocalStorage) {
      setLogin("Log Out");
    } else {
      setLogin("Log In");
    }
  });

  const currentPath =
    window.location.pathname.includes("login") ||
    window.location.pathname.includes("admin");
  console.log(currentPath);
  useEffect(() => {});
  const sessionLogOut = () => {
    localStorage.getItem("token");
    localStorage.clear();
    sessionStorage.clear();

    console.log("localStorage", localStorage.getItem("token"));
    console.log("sessionStorage", sessionStorage.getItem("token"));
  };
  return (
    <>
      <div>
        {/* <h1>Header Component</h1> */}

        <nav
          className="navbar navbar-expand-lg btn-primary-custom"
          // className="navbar navbar-expand-lg"
          aria-label="Offcanvas navbar large"
        >
          <div className="container-fluid">
            <NavLink to="/" className="text-white">
              <img
                className=""
                src="/assets/img/logo/logo_trans.png"
                alt=""
                style={{ height: "50px" }}
              />
            </NavLink>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasNavbar2"
              aria-controls="offcanvasNavbar2"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <div
              // className="offcanvas offcanvas-start text-bg-dark"
              className="offcanvas offcanvas-start"
              style={{ background: "#a07be1" }}
              // style={{ background: "#622569" }}
              // tabindex="-1"
              id="offcanvasNavbar2"
              aria-labelledby="offcanvasNavbar2Label"
            >
              <div
                className="offcanvas-header"
                // style={{ background: "#a07be1" }}
                style={{ background: "#622569" }}
              >
                <h5 className="offcanvas-title" id="offcanvasNavbar2Label">
                  <NavLink to="/" className="text-white">
                    {/* Logo */}
                    <img
                      src="/assets/img/logo/logo_trans.png"
                      alt=""
                      style={{ height: "32px" }}
                    />
                  </NavLink>
                </h5>
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  data-bs-dismiss="offcanvas"
                  aria-label="Close"
                ></button>
              </div>
              <div className="offcanvas-body">
                {/* <ul className="navbar-nav justify-content-end flex-grow-1 pe-3"> */}
                <ul className="navbar-nav text-white justify-content-center flex-grow-1 pe-3 header">
                  <NavLink to="/">
                    <LuHotel size={24} />
                    <li> Home</li>
                  </NavLink>
                  <NavLink to="rooms">
                    <PiBuildingApartmentThin size={24} />
                    <li>Rooms</li>
                  </NavLink>
                 
                    <NavLink to="booking">
                      <PiMoney size={24} />
                      <li>Booking</li>
                    </NavLink>
                 
                  <NavLink to="about">
                    <BiSolidUserDetail size={24} />
                    <li>About Us</li>
                  </NavLink>
                  <NavLink to="contact">
                    <TiMessage size={24} />
                    <li>Contact Us</li>
                  </NavLink>
                </ul>
                {/* <ul className="navbar-nav justify-content-end flex-grow-1 pe-3 socialIcon d-sm-none d-none d-lg-block d-md-none"> */}
                <ul className="navbar-nav justify-content-end flex-grow-1 pe-3 socialIcon ">
                  <NavLink
                    to={"https://www.instagram.com/hotel_bgm/"}
                    target="_blank"
                  >
                    <li className="me-2 px-2">
                      <CiInstagram size={24} />
                    </li>
                  </NavLink>
                  <NavLink
                    to={
                      "https://www.facebook.com/profile.php?id=61566936007789"
                    }
                    target="_blank"
                  >
                    <li className="me-2 px-2">
                      <FiFacebook size={24} />
                    </li>
                  </NavLink>
                  <NavLink
                    to={"https://www.youtube.com/@HotelBGM"}
                    target="_blank"
                  >
                    <li className="me-2 px-2">
                      <CiYoutube size={24} />
                    </li>
                  </NavLink>
                </ul>
                <ul>
                  {(currentPath && (
                    <NavLink to={"login"}>
                      <li onClick={sessionLogOut}>{login}</li>
                    </NavLink>
                  )) ||
                    ""}
                </ul>
              </div>
            </div>
          </div>
        </nav>
      </div>
    </>
  );
}
